
import {Vue, Component, Prop} from 'vue-property-decorator';

@Component({})
export default class vGenericTable extends Vue {
  @Prop({ default: "" }) theadClass?: string;
  @Prop({ default: "" }) tbodyClass?: string;
}
